// extracted by mini-css-extract-plugin
export default {"inputsBox":"ForgotPasswordCRMForm_inputsBox__KC3UC","submitButtonBox":"ForgotPasswordCRMForm_submitButtonBox__13XNx"};